"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withdraw = exports.deposit = void 0;
const ethers_1 = require("ethers");
const constants_1 = require("../constants");
const types_1 = require("../constants/types");
const utils_1 = require("../utils");
function deposit(chainId, collateral, stablecoin, signer, amount, user = '', options = {}) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const stable = (0, utils_1.parseStable)(stablecoin);
        const collat = (0, utils_1.parseCollat)(collateral);
        const stableMasterAddress = (_a = (0, constants_1.registry)(chainId, stable.symbol)) === null || _a === void 0 ? void 0 : _a.StableMaster;
        const poolManagerAddress = (_b = (0, constants_1.registry)(chainId, stable.symbol, collat.symbol)) === null || _b === void 0 ? void 0 : _b.PoolManager;
        if (!stableMasterAddress || !poolManagerAddress)
            throw new Error("Can't find contract's address");
        if (!ethers_1.ethers.utils.isAddress(user))
            user = yield signer.getAddress();
        const approval = yield types_1.Erc20__factory.connect(collat.address, signer).allowance(yield signer.getAddress(), stableMasterAddress);
        if (approval.lt(amount))
            console.error('The StableMaster needs to be approved');
        return types_1.StableMasterFront__factory.connect(stableMasterAddress, signer).deposit(amount, user, poolManagerAddress, options);
    });
}
exports.deposit = deposit;
function withdraw(chainId, collateral, stablecoin, signer, amount, burner = '', dest = '', options = {}) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const stable = (0, utils_1.parseStable)(stablecoin);
        const collat = (0, utils_1.parseCollat)(collateral);
        const stableMasterAddress = (_a = (0, constants_1.registry)(chainId, stable.symbol)) === null || _a === void 0 ? void 0 : _a.StableMaster;
        const poolManagerAddress = (_b = (0, constants_1.registry)(chainId, stable.symbol, collat.symbol)) === null || _b === void 0 ? void 0 : _b.PoolManager;
        if (!stableMasterAddress || !poolManagerAddress)
            throw new Error("Can't find contract's address");
        if (!ethers_1.ethers.utils.isAddress(burner))
            burner = yield signer.getAddress();
        if (!ethers_1.ethers.utils.isAddress(dest))
            dest = yield signer.getAddress();
        return types_1.StableMasterFront__factory.connect(stableMasterAddress, signer).withdraw(amount, burner, dest, poolManagerAddress, options);
    });
}
exports.withdraw = withdraw;
//# sourceMappingURL=slp.js.map